var map = {
	"./404.svg": "a14a",
	"./audit.svg": "d393",
	"./bug.svg": "1779",
	"./callcenter01.svg": "e1a8",
	"./ceo.svg": "26a1",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./icon.svg": "9d91",
	"./inspector.svg": "1ab2",
	"./international.svg": "17df",
	"./inventory.svg": "faa7",
	"./invoices.svg": "7b93",
	"./language.svg": "2580",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./password.svg": "2a3d",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./shoppingCard.svg": "c6c1",
	"./star.svg": "708a",
	"./supervisor.svg": "461c",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d88";